import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const registrationSettingsSlice = createSlice({
    name: "registrationSettings",
    initialState,
    reducers: {
        settingsAdded(state, action) {
            return state = action.payload;
        }
    }
});

export const registrationSettingsSelector = (state) => state.registrationSettings;

export const { settingsAdded } = registrationSettingsSlice.actions;
export default registrationSettingsSlice.reducer;